export default {
    items: [
        {
            name: 'Dashboard',
            url: '/approvals',
            icon: 'cui-dashboard',
            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'FM - Facilities Management',
            url: '/approvals',
            icon: '',
            badge: {
                variant: 'primary',
            },
            children: [
                {
                    name: 'Work Orders',
                    url: '/approvals/orders',
                    icon: 'icon-basket-loaded',
                },
                {
                    name: 'Payment Voucher',
                    url: '/approvals/fm-payment-vouchers',
                    icon: 'cui-dollar',
                },
            ]
        },
        {
            name: 'LM - Lease Management',
            url: '/settings',
            icon: '',
            badge: {
                variant: 'primary',
            },
            children: [
                {
                    name: 'Payment Voucher',
                    url: '/approvals/lm-payment-vouchers',
                    icon: 'cui-dollar',
                },
                {
                    name: 'Credit Note',
                    url: '/approvals/credit-note',
                    icon: 'icon-layers',
                },
                {
                    name: 'Offset Documents',
                    url: '/approvals/offset-documents',
                    icon: 'icon-star',
                },
            ]
        }
    ]
}